import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Table from 'components/application/Table';

import TeamsRow from 'components/teams/TeamsRow';

export default function TeamsTable({ onTeamSelection, teams }) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const mappedCompanies = teams.includedCompanies.reduce((acc, company) => {
    acc[company.id] = company;
    return acc;
  }, {});

  const mappedManagers = teams.includedManagers.reduce((acc, manager) => {
    acc[manager.id] = manager;
    return acc;
  }, {});

  return (
    <Table
      headers={
        <tr>
          <th className='w-36 tw-text-s tw-font-medium tw-tracking-wide tw-text-grey-900'>
            {i18nTShared('team')}
          </th>
          <th className='w-30 tw-text-s tw-font-medium tw-tracking-wide tw-text-grey-900'>
            {i18nTShared('teamManagers')}
          </th>
          <th className='w-19 tw-text-s tw-font-medium tw-tracking-wide tw-text-grey-900'>
            {i18nTShared('division')}
          </th>
          <th className='w-14 tw-text-center tw-text-s tw-font-medium tw-tracking-wide tw-text-grey-900'>
            {i18nTShared('members')}
          </th>
        </tr>
      }
      rows={teams.collection.map((team) => {
        const managers =
          team.relationships.managers ?
            team.relationships.managers.data.map(
              (manager) => mappedManagers[manager.id],
            )
          : [];
        return (
          <TeamsRow
            company={mappedCompanies[team.relationships.company.data.id]}
            key={team.id}
            managers={managers}
            onTeamRowClick={onTeamSelection}
            team={team}
          />
        );
      })}
    />
  );
}

TeamsTable.propTypes = {
  teams: PropTypes.shape({
    collection: PropTypes.array.isRequired,
  }).isRequired,
  onTeamSelection: PropTypes.func.isRequired,
};
